import { render, staticRenderFns } from "./vivaelogin.vue?vue&type=template&id=04a3ef9b&"
import script from "./vivaelogin.vue?vue&type=script&lang=js&"
export * from "./vivaelogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports